import Typography from "@common/components/Typography";
import {
  Divider,
  CardContent as MuiCardContent,
  styled,
  Tooltip,
} from "@mui/material";
import React from "react";

type DeviceCardInformationsType = {
  name?: string;
  label1?: string;
  label2?: string;
};

const CardContent = styled(MuiCardContent)(({ theme }) => ({
  width: "100%",
  "& p": {
    textAlign: "left",
  },
}));

const DeviceCardInformations = (props: DeviceCardInformationsType) => {
  return (
    <CardContent>
      <Tooltip arrow title={props.name ?? ""}>
        <Typography
          size="small"
          sx={{
            fontWeight: 600,
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
          }}
        >
          {props.name}
        </Typography>
      </Tooltip>
      <Tooltip arrow title={props.label1 ?? ""}>
        <Typography
          size="small"
          sx={{
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
          }}
        >
          {props.label1}
        </Typography>
      </Tooltip>
      <Tooltip arrow title={props.label2 ?? ""}>
        {props.label2 !== "Unknown" ? (
          <Typography
            size="small"
            sx={{
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
            }}
          >
            {props.label2}
          </Typography>
        ) : (
          <Divider
            sx={{
              bgcolor: ({ palette }) => palette.common.grey.g5C5C5C,
              my: 1,
              width: "2rem",
              borderBottomWidth: 3,
            }}
          />
        )}
      </Tooltip>
    </CardContent>
  );
};

export default DeviceCardInformations;
